var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bxKbjs box noBtn"},[_c('div',{staticClass:"jsy"},[_c('p',[_vm._v("本次开标到此结束！")]),_c('p',[_vm._v("谢谢大家！")])])])
}]

export { render, staticRenderFns }